import Car from "@/assets/icons/Car";
import Clock from "@/assets/icons/Clock";
import AppButton from "@/components/shared/AppButton";
import { Card } from "@/components/shared/Card";
import { HStack } from "@/components/ui/hstack";
import { Text } from "@/components/ui/text";
import { VStack } from "@/components/ui/vstack";
import { getUserTimezoneAbbreviation } from "@/utils/dateUtils";
import { T, useT } from "@transifex/react";
import type { Session } from "ipctg-inflow-types/InFlowDB";

const formatTime = (date: string): string => new Date(date).toLocaleTimeString([], { hour: "numeric", minute: "2-digit" });

const formatShortDate = (date: string): string => new Date(date).toLocaleDateString();

interface ActiveSessionCardProps {
  session: Session;
  canExtend: boolean;
  onExtend: (sessionID: string) => void;
}

export const ActiveSessionCard = ({ session, canExtend, onExtend }: ActiveSessionCardProps) => {
  const t = useT();
  const { plate, endDateTime } = session;
  const timezone = getUserTimezoneAbbreviation();

  const sessionMessage = t("Session expires: {endDate} {endTime} {userTimeZone}", {
    endDate: formatShortDate(endDateTime),
    endTime: formatTime(endDateTime),
    userTimeZone: timezone,
  });

  return (
    <Card className="pt-[20px] pb-[24px] px-[20px]">
      <VStack className="gap-y-1">
        <Text className="text-typography-900 text-lg font-bold leading-[18px]">
          <T _str="Active Session" />
        </Text>
        <HStack className="items-center gap-2 pt-2">
          <Car />
          <Text className="text-md font-bold text-typography-900">{plate}</Text>
        </HStack>

        <HStack className="items-center pb-3">
          <Text className="text-[14px] text-typography-900">{sessionMessage}</Text>
        </HStack>

        {canExtend && <AppButton onPress={() => onExtend(session.sessionID)} title={t("Extend Session")} icon={Clock} />}
      </VStack>
    </Card>
  );
};
